import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AssetThumbnail from "../AssetThumbnail/AssetThumbnail";
import PhotoProducts from "../PhotoProducts/PhotoProducts";
import AssetDetails from "../AssetDetails/AssetDetails";
import Dotdotdot from "react-dotdotdot";
import Common from "../../utils/common";
import Analytics from "../../libs/analytics";
import "./PhotoViewer.scss";

const PhotoViewer = ({ photo, ambassador, userTotalVideos }) => {
    const [renderProducts, setRenderProducts] = useState(false);

    const customWidth = useMemo(() => {
        const qty = photo.matched.length;
        return qty <= 2
            ? {
                  photoClass: " tvp-reset-padding",
                  productsClass: " tvp-reset-padding",
                  photoAreaSx: { xs: 12, lg: 8 },
                  productsAreaSx: { xs: 12, lg: 4 },
              }
            : {
                  photoClass: " ",
                  productsClass: " ",
                  photoAreaSx: { xs: 12, lg: 6 },
                  productsAreaSx: { xs: 12, lg: 6 },
              };
    }, [photo.matched.length]);
    
    const photoUrl = photo.asset.sources[0].url;
    const userHashId = ambassador?.hashId || null;
    const publishedDate = Common.getNewDateFromUnix(photo.date_created);

    useEffect(() => {
        Analytics.photoView(photo);
        const t = setTimeout(() => setRenderProducts(true), 100);
        return () => clearTimeout(t);
    }, [photo]);

    return (
        <Box className="tvp-photo-wrapper">
            <Grid container spacing={2}>
                <Grid item container className="tvp-photo-row">
                    <div
                        id="video-playing-title-holder"
                        className="clearfix col-12"
                    >
                        <h1
                            id="video-playing-title"
                            className="video-playing-title"
                        >
                            <Dotdotdot clamp={2}>{photo.title}</Dotdotdot>
                        </h1>
                    </div>
                </Grid>

                <Grid item container>
                    <AssetDetails
                        asset={photo}
                        ambassador={ambassador}
                        enableAmbassador
                        publishedDate={publishedDate}
                        userTotalVideos={userTotalVideos}
                    />
                </Grid>

                <Grid
                    item
                    {...customWidth.photoAreaSx}
                    className={`tvp-photo-container${customWidth.photoClass}`}
                >
                    <div className="tvp-photo-holder">
                        <AssetThumbnail thumbnailUrl={photoUrl} />
                    </div>
                </Grid>

                <Grid
                    item
                    {...customWidth.productsAreaSx}
                    className={`tvp-product-container${customWidth.productsClass}`}
                >
                    {renderProducts && (
                        <PhotoProducts
                            ambassador={ambassador}
                            userHashId={userHashId}
                            products={photo.matched}
                            asset={photo}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default PhotoViewer;
